import type CalendarState from "../calendarState";
import {Action} from "../../../action/action";
import { PackageTemplate } from "@raskrask-dk/raskrask-utils";


export const CHOOSE_PACKAGE = "CHOOSE_PACKAGE";
export class ChoosePackage extends Action<typeof CHOOSE_PACKAGE, PackageTemplate> {
  readonly type = CHOOSE_PACKAGE;
  protected state: CalendarState;

  constructor(state: CalendarState) {
    super(state);
    this.state = state;
  }

  public isValid(): boolean {
    return this.isDoable();
  }

  /**
   * Not implemented yet
   * @returns whether the package button should be an option
   */
  public isDoable(): boolean {
    const {serviceType, goal, customerType} = this.state;
    const isCustomerPrivate = customerType === "Private";
    const isRequiredValuesSet = this.allHasValues(serviceType, goal);
    return isRequiredValuesSet && isCustomerPrivate;
  }
}
